import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useSelector } from 'react-redux';
import { T } from 'shared/helper/translate';
import WeChatBindingQR from './WeChatBindingQR';
var LinkedAccounts = function LinkedAccounts() {
  var weChatLinked = useSelector(function (_ref) {
    var _user$linkedAccounts;
    var user = _ref.user;
    return user === null || user === void 0 || (_user$linkedAccounts = user.linkedAccounts) === null || _user$linkedAccounts === void 0 ? void 0 : _user$linkedAccounts.includes('wechat');
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "col-md-8"
  }, /*#__PURE__*/React.createElement("h2", null, /*#__PURE__*/React.createElement(T, {
    source: "wechat"
  }), " ", /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-brands fa-weixin"
  })), weChatLinked ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "display-2",
    icon: "fa-solid fa-check"
  }) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(T, {
    source: "wechat-linking-instructions"
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(WeChatBindingQR, null)));
};
export default LinkedAccounts;